import r from"react";import e from"./Modal.less.js";var o=function(o){var t=o.children;return r.createElement("div",{className:e["modal-footer"]},t)};export{o as ModalFooter};
//# sourceMappingURL=ModalFooter.js.map
